// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3714":"03c09a92","3873":"7af50f42","4854":"c86cf219"}[chunkId] + ".chunk.css";
};